
<div>
  <Navigation :view="'login'" />
  <b-overlay :show="loading">
    <b-jumbotron header="Välj användare">
      <template #lead v-if="desktop">
        Möjligheten att logga in med användarkontot från webappen
        (<code>sttylus.se/app/</code>) dröjer tills den är vattentät i alla
        riktningar. Tills dess loggar du in som "Skrivtolk" och du kan
        fortfarande importera dina förkortningslistor från webappen.<br />
      </template>
      <div v-if="desktop && users">
        <b-list-group v-for="user in users" v-bind:key="user['id']"
          ><b-list-group-item href="#" @dblclick="loginAs(user)"
            ><b-button variant="primary" @dblclick="loginAs(user)"
              >Logga in</b-button
            >
            {{ user['name'] }}</b-list-group-item
          ></b-list-group
        >
        <hr />
      </div>

      <div v-if="!desktop">
        <h1>Logga in</h1>
        <div v-if="step == 0">
          <b-form @submit.prevent="next">
            <b-form-group label="E-post">
              <b-form-input type="email" v-model="form.email" />
            </b-form-group>

            <b-button variant="info" type="submit">Nästa</b-button>
            <span v-if="error" class="text-danger"> {{ error }}</span>
          </b-form>
        </div>
        <div v-if="step == 1">
          <div v-if="passwordprompt == 'sync'">
            STTylus kommer att synka dina lokala filer med användardata som
            finns på webben.
          </div>
          <div v-if="passwordprompt == 'login' || passwordprompt == 'sync'">
            <ValidationObserver v-slot="{ handleSubmit }">
              <b-form @submit.prevent="handleSubmit(onSubmit)">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <b-form-group label="Lösenord">
                    <b-form-input
                      type="password"
                      :state="valid"
                      v-model="form.password"
                      autofocus
                    />
                    <span>{{ errors[0] }}</span>
                  </b-form-group>
                </ValidationProvider>

                <b-button variant="info" type="submit">Logga in</b-button>
              </b-form>
            </ValidationObserver>
            {{ syncResponse }}
          </div>
          <div v-if="passwordprompt == 'register'">
            I och med att detta är din första inloggning så väljer du ditt
            lösenord nedan.
          </div>
          <div v-if="passwordprompt == 'reset'">
            Lösenordet för ditt konto har nollställts. Skapa ett nytt lösenord
            nedan.
          </div>
          <div
            v-if="passwordprompt == 'register' || passwordprompt == 'reset'"
          >
            <ValidationObserver v-slot="{ handleSubmit }">
              <b-form @submit.prevent="handleSubmit(onSubmit)">
                <ValidationProvider
                  rules="required|confirmed:confirm"
                  vid="password"
                  v-slot="{ errors, valid }"
                >
                  <b-form-group label="Lösenord">
                    <b-form-input
                      type="password"
                      :state="valid"
                      v-model="form.password"
                      autofocus
                    />
                    <span>{{ errors[0] }}</span>
                  </b-form-group>
                </ValidationProvider>

                <ValidationProvider
                  vid="confirm"
                  rules="required|confirmed:password"
                  v-slot="{ errors, valid }"
                >
                  <b-form-group label="Bekräfta lösenord">
                    <b-form-input
                      :state="valid"
                      type="password"
                      v-model="form.confirm"
                    />
                    <span>{{ errors[0] }}</span>
                  </b-form-group>
                </ValidationProvider>
                <span v-if="passwordprompt == 'register'">
                  <b-button variant="info" type="submit">Registrera</b-button>
                </span>
                <span v-if="passwordprompt == 'reset'">
                  <b-button variant="info" type="submit"
                    >Skapa nytt lösenord</b-button
                  >
                </span>
              </b-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </b-jumbotron>
    <template #overlay>
      <div class="text-center">
        <div v-if="passwordprompt == 'register'">
          <b-spinner label="Skapar användare..." />
          <p>Vänta medan din användare skapas...</p>
        </div>
        <div v-else>
          <b-spinner label="Synkroniserar användare..." />
          <p>Vänta medan din användare laddas ner...</p>
        </div>
      </div>
    </template>
  </b-overlay>
  <!--<b-jumbotron>
    <h2>Testa STTylus</h2>
    Om du inte har ett registrerat konto så kan du köra ett begränsat
    testkonto.<br />
    Är du intresserad av att registrera ett konto så kontaktar du
    info@sttylus.se.<br />
    <b-button variant="info" type="submit" @click.prevent="onLoginTester"
      >Logga in med testkonto</b-button
    >
  </b-jumbotron>-->
</div>
